module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_sp_005-09dafddee93708076ed94fd5d65680d7.png";